import { dispatcher, ingenuity } from "@quest/base-core";
import { PlayerMsgController, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";

import { GameParserModel } from "../Platform/GameParserModel";

export class PlayerMsgControllerGame extends PlayerMsgController {
  // Overrided to update console win meter in free game in case of base game with no win
  protected initializeElements() {
    super.initializeElements();
    if ((ingenuity.parserModel as GameParserModel).getFreeSpinTotalWin()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOTAL_WIN_MSG_FG_BROKEN);
    }
  }
}
